import contentTransform from './contentTransform.vue'
export default contentTransform
